module.exports = __webpack_public_path__ + "img/champ_info_img.e5e986ae.webp";